<template>
  <div :style="tankStyle" class="tank-group">
    <div class="cmp-handle" style="z-index:999">
      <el-dropdown>
        <span class="el-dropdown-link">
          <i class="el-input__icon el-icon-more"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="settingVisible=true"
                            style="text-align: center">设置
          </el-dropdown-item>
          <el-dropdown-item @click.native="handleCmp('delete',componentIndex)"
                            style="text-align: center">删除
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
<!--    显示范围设置逻辑待修改-->
    <el-dialog
        :append-to-body="true"
        :visible.sync="settingVisible"
        title="设置"
        width="30%">
      <el-input v-model="min" style="width: 200px;margin-bottom: 10px">
        <template slot="prepend">Min</template>
      </el-input>
      <el-input v-model="max" style="width: 200px">
        <template slot="prepend">Max</template>
      </el-input>
      <span class="dialog-footer" slot="footer">
        <el-button @click="settingVisible = false">取 消</el-button>
        <el-button @click="settingConfirm(),settingVisible = false" type="primary">确 定</el-button>
      </span>
    </el-dialog>
    <tankChart ref="tankChart" :min="min" :max="max" style="width: 95%;height: 90%;margin:5% 2.5% 5% 2.5%;"></tankChart>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
import TankChart from '../common/echarts/TankChart';

export default {
  name: 'Tank',
  components: {
    tankChart: TankChart,
  },
  props: {
    componentIndex: {
      type: Number,
    },
  },
  data() {
    return {
      min: '0',
      max: '10',
      settingVisible: false,
      tankStyle: 'width: 100%;height:100%',
    };
  },
  methods: {
    ...mapActions('Engineering', ['deleteCpt']),
    handleCmp(command, index) {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      switch (command) {
        case 'delete':
          this.deleteCpt({ index });
          break;
        default:
          break;
      }
    },
    settingConfirm() {
      this.$refs.tankChart.initChart();
    },
  },
  computed: {
    ...mapGetters('Engineering', ['getCurCmpStatus']),
  },
  mounted() {
  },
};
</script>

<style scoped>
  .el-input__icon {
    line-height: 25px;
    opacity: 0;
  }
  .cmp-handle {
    position: absolute;
    top: 0;
    right: 0;
  }
  .tank-group{
    overflow: hidden !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/engineering/Tank.vue